import {
  AmplitudeBrowserTrackingClient,
  ConsoleTrackingClient,
  createEventsCore,
} from '@apollo-frontend/tracking-core';

import { ApiKey } from '../analytics/amplitude/vendor';

import type { TrackingEvents } from './generated/taxonomy';

const trackingClient = () => {
  const amplitudeApiKey =
    process.env.NODE_ENV === 'production' ? ApiKey.prod : ApiKey.staging;

  if (amplitudeApiKey) {
    return AmplitudeBrowserTrackingClient.create({
      apiKey: amplitudeApiKey,
      environment:
        process.env.NODE_ENV === 'production' ? 'production' : 'staging',
      product: 'studio',
    });
  } else {
    // logs tracks to console for folks who do not have the key setup
    return new ConsoleTrackingClient();
  }
};

export const events = createEventsCore<TrackingEvents>(trackingClient);
